import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import { XMarkIcon } from "@heroicons/react/24/solid";

export interface ImageLightboxProps {
  open: boolean;
  imageUrl: string;
  onClose: () => void;
}

const ImageLightbox: React.FC<ImageLightboxProps> = ({ open, imageUrl, onClose }) => {
  const fixedWidth = 800; 
  const fixedHeight = 600;

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false}>
      <DialogContent
        sx={{
          position: "relative",
          p: 0,
          width: fixedWidth,
          height: fixedHeight,
          maxWidth: "90vw",
          maxHeight: "90vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "black",
        }}
      >
        <button
          onClick={onClose}
          aria-label="close"
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            background: "transparent",
            border: "none",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          <XMarkIcon style={{ width: 24, height: 24, color: "white" }} />
        </button>
        <img
          src={imageUrl}
          alt="Preview"
          style={{
            maxWidth: "100%",
            maxHeight: "100%",
            objectFit: "contain",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ImageLightbox;
